import { getAnalytics } from "firebase/analytics";
import { FirebaseOptions, initializeApp } from "firebase/app";
// import { ReCaptchaV3Provider, initializeAppCheck } from "firebase/app-check"; // Disabled - not needed with Supabase
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig: FirebaseOptions = {
  apiKey: process.env.REACT_APP_APIKEY,
  authDomain: process.env.REACT_APP_AUTHDOMAIN,
  databaseURL: process.env.REACT_APP_DATABASEURL,
  projectId: process.env.REACT_APP_PROJECTID,
  storageBucket: process.env.REACT_APP_STORAGEBUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
  measurementId: process.env.REACT_APP_MEASUREMENTID,
  appId: process.env.REACT_APP_APPID,
};

export const firebase = initializeApp(firebaseConfig);

/* auth component */
export const auth = getAuth(firebase);

/* anaylytics component */
export const analytics = getAnalytics(firebase);

/* appcheck - Disabled since using Supabase as primary database */
// App Check is only needed if you're using Firebase services that require it
// Since we're using Supabase with Firebase auth only, we can disable this
// if (process.env.REACT_APP_FIREBASE_APPCHECK_DEBUG_TOKEN === "true") {
//   window.FIREBASE_APPCHECK_DEBUG_TOKEN = true;
// }
// export const appcheck = initializeAppCheck(firebase, {
//   provider: new ReCaptchaV3Provider(process.env.REACT_APP_CAPTCHA_KEY!),
//   isTokenAutoRefreshEnabled: true,
// });

/* firestore component */
export const firestore = getFirestore(firebase);

// Export Firebase WordService implementation
export { FirebaseWordService } from "./FirebaseWordService";
